import React, { useState } from "react";

const Format = () => {
  const [copied, setCopied] = useState(null);

  // ===== Existing states =====
  const [transactions, setTransactions] = useState([{ merchant: "", date: "", amount: "" }]);
  const [mobile, setMobile] = useState("");
  const [cardNumberAxis, setCardNumberAxis] = useState("");
  const [amount, setAmount] = useState("");
  const [userName, setUserName] = useState("");

  // ===== NEW: CC Bill Pay (Payout) Format states =====
  const [ccRegMobile, setCcRegMobile] = useState("");
  const [ccCardNumber, setCcCardNumber] = useState("");
  const [ccBank, setCcBank] = useState("");
  const [ccAmount, setCcAmount] = useState("");
  const [ccPaste, setCcPaste] = useState(""); // optional: paste any text/json and try to extract

  // =========================
  // Helpers
  // =========================
  const handleCopyText = (text, type) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopied(type);
        setTimeout(() => setCopied(null), 2000);
      })
      .catch((err) => console.error("Failed to copy: ", err));
  };

  const handleCopyKeys = (keys, type) => {
    handleCopyText(keys.join("\n"), type);
  };

  const normalizeDigits = (v) => (v || "").toString().replace(/[^\d]/g, "");

  const tryExtractCcBillPay = () => {
    if (!ccPaste) return;

    // 1) Try JSON
    try {
      const obj = JSON.parse(ccPaste);

      const getAny = (candidates) => {
        for (const c of candidates) {
          const v = c?.(obj);
          if (v !== undefined && v !== null && v !== "") return v;
        }
        return "";
      };

      

      return;
    } catch (e) {
      // Not JSON — fall back to text parsing
    }

    // 2) Text parsing: look for common labels
    const text = ccPaste;

    


  };

 

  const addTransaction = () => {
    setTransactions([...transactions, { merchant: "", date: "", amount: "" }]);
  };

  // =========================
  // Existing formats
  // =========================
  const phonePeDetails = (amt) => [
    "PhonePe Number: 9392763880",
    "Name: Sravani Poukri",
    `Amount: ₹${amt}`,
    "Please send the amount and share the screenshot after the payment.",
  ];

  const payinKeys = [
    "Cardholder Name:",
    "Mobile Number:",
    "Card Number:",
    "Expiration Date:",
    "CVV:",
    "Amount:",
    "Bank Name:",
    "Card Type:",
    "Card Bill Genarate Date:",
    "Cartd Bill Due Date:"
  ];

  const payoutKeys = [
    "Bank Holder Name :- ",
    "Mobile Number :-",
    "Account Number :- ",
    "Bank Name :- ",
    "IFSC :- ",
    "UPI :-",
  ];

  // =========================
  // NEW: CC Bill Pay payout format
  // =========================
  const ccBillPayKeys = [
    "Register Mobile Number:-",
    "Card Number:-",
    "Bank:-",
    "Amount:-",
  ];

  const buildCcBillPayText = () => {
    // Keep exactly your requested labels
    const regMobile = ccRegMobile || "";
    const cardNo = ccCardNumber || "";
    const bank = ccBank || "";
    const amt = ccAmount || "";

    return [
      `Register Mobile Number:- ${regMobile || "N/A"}`,
      `Card Number:- ${cardNo || "N/A"}`,
      `Bank:- ${bank || "N/A"}`,
      `Amount:- ${amt || "N/A"}`,
    ].join("\n");
  };


  return (
    <div className="mt-4">
      
      <div className="mb-4">
        <h4>Payin</h4>
        <button className="btn btn-primary" onClick={() => handleCopyKeys(payinKeys, "Payin")}>
          Copy Payin Keys
        </button>
        {copied === "Payin" && <span className="ms-2 text-success">Copied!</span>}
      </div>

      {/* Payout Section */}
      <div className="mb-4">
        <h4>Payout</h4>
        <button className="btn btn-primary" onClick={() => handleCopyKeys(payoutKeys, "Payout")}>
          Copy Payout Keys
        </button>
        {copied === "Payout" && <span className="ms-2 text-success">Copied!</span>}
      </div>
      <div className="mb-4">
        <h4>CC Bill Pay Fromat</h4>
        <button className="btn btn-primary" onClick={() => handleCopyKeys(ccBillPayKeys, "CCBillPayKeys")}>
          Copy CC Bill Pay Fromat
        </button>
        {copied === "CCBillPayKeys" && <span className="ms-2 text-success">Copied!</span>}
      </div>


    </div>
  );
};

export default Format;
